import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Paper, TextField, Button, Grid, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const DaminhaPajem = () => {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ nome: '', tipo: 'daminha' });
  const [editId, setEditId] = useState(null);

  const fetchData = async () => {
    const res = await axios.get('/api/daminha_pajem');
    setDados(res.data);
  };

  useEffect(() => { fetchData(); }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleTipo = e => setForm({ ...form, tipo: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (editId) {
      await axios.put(`/api/daminha_pajem/${editId}`, form);
    } else {
      await axios.post('/api/daminha_pajem', form);
    }
    setForm({ nome: '', tipo: 'daminha' });
    setEditId(null);
    fetchData();
  };

  const handleEdit = item => {
    setForm(item);
    setEditId(item.id);
  };

  const handleDelete = async id => {
    await axios.delete(`/api/daminha_pajem/${id}`);
    fetchData();
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Daminha e Pajem</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={8}><TextField label="Nome" name="nome" value={form.nome} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={4}>
              <RadioGroup row value={form.tipo} onChange={handleTipo}>
                <FormControlLabel value="daminha" control={<Radio />} label="Daminha" />
                <FormControlLabel value="pajem" control={<Radio />} label="Pajem" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}><Button type="submit" variant="contained">{editId ? 'Salvar' : 'Adicionar'}</Button></Grid>
          </Grid>
        </form>
      </Paper>
      {dados.map(item => (
        <Paper key={item.id} sx={{ p: 2, mb: 1 }}>
          <Typography><b>Nome:</b> {item.nome}</Typography>
          <Typography><b>Tipo:</b> {item.tipo === 'daminha' ? 'Daminha' : 'Pajem'}</Typography>
          <Button onClick={() => handleEdit(item)} sx={{ mr: 1 }}>Editar</Button>
          <Button color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
        </Paper>
      ))}
    </Container>
  );
};

export default DaminhaPajem;
